module.exports = __webpack_public_path__ + "img/main.45bdd528.jpg";